import { useEffect, useState } from "react";
import API from "../../services/api";
import { Link } from "react-router-dom";

function ManageProducts() {

  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await API.get("/api/products?page=0&size=100");
      setProducts(res.data.content || []);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteProduct = async (id) => {
    try {
      await API.delete(`/api/admin/products/deleteProduct/${id}`);
      alert("Deleted");
      fetchProducts();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="container mt-5">

      <h2>Manage Products</h2>

      <table className="table mt-4">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Price</th>
            <th>Stock</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {products?.map((p) => (
            <tr key={p.id}>
              <td>{p.id}</td>
              <td>{p.name}</td>
              <td>{p.price}</td>
              <td>{p.stock}</td>

              <td>
                <Link to={`/admin/edit-product/${p.id}`}>
                  <button className="btn btn-warning me-2">Edit</button>
                </Link>

                <button
                  className="btn btn-danger"
                  onClick={() => deleteProduct(p.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>

      </table>

    </div>
  );
}

export default ManageProducts;